
<template>

  <div class="text-center grey lighten-5" style="padding-top:100px;height:700px">
      <div v-role="'est'" class="text-center">

    <h2 style="text-align:Center;">Menu Exportação </h2><br>
  </div>
    <v-row>
      <v-col cols="12" md="4">
        </v-col>
      <v-col cols="12" md="2">
    <!-- Menu Estudante -->

      <template>
       <v-btn class="mx-2" fab dark x-large color="primary"  @click="$router.push('EstudantesExport_Dados_cloud')">
         <v-icon dark>sync</v-icon>
        </v-btn>
      </template>
    <br>
    Sincronização<br>
    <span style="color:gray;font-size:12px">Se conectado a internet, envia dados ao servidor remoto (Não necessito Pendrive)</span>
    </v-col>
    <!--Fim Menu Estudante -->

<!-- Menu Professor -->
<v-col cols="12" md="2">

      <template >
       <v-btn class="mx-2" fab dark x-large color="indigo" @click="$router.push('EstudantesExport_Dados')">
         <v-icon dark>dns</v-icon>
        </v-btn>
      </template>

     <br>
    Baixar<br>
    <span style="color:gray;font-size:12px">Utiliza essa função se quiser baixar ficheiros no seu computador e transportar por meio de um dispositivo removível (Pendrive).</span>
    </v-col>
    <!--Fim menu Armazenamento interno -->
    </v-row>
    <div style="padding-top:200px"></div>
  </div>
</template>

<script>
const ls = require('local-storage')
export default {
  data: () => ({
    instituicaodescricao: ls.get('instituicaodescricao'),
    fav: true,
    menuEstudante: false,
    menuProfessor: false,
    menuTurmas: false,
    message: false,
    hints: true
  })
}
</script>
